import React, { useState, useRef, useEffect } from "react";

import useKeypress from "react-use-keypress";

import ReactCrop, {
  centerCrop,
  makeAspectCrop,
  Crop,
  PixelCrop,
  convertToPixelCrop,
} from "react-image-crop";
import { canvasPreview } from "./canvasPreview";
import Button from "@mui/joy/Button";
import FileDownload from "@mui/icons-material/FileDownload";
import {
  ArrowForward,
  ArrowBack,
  Clear,
  Search,
  ZoomInMap,
  ZoomOutMap,
  Rotate90DegreesCw,
} from "@mui/icons-material";
import Textarea from "@mui/joy/Textarea";

import "react-image-crop/dist/ReactCrop.css";

type Member = {
  serial: string;
  membership_type: string;
  profile_image_url: string | undefined;
};

// This is to demonstate how to make and center a % aspect crop
// which is a bit trickier so we use some helper functions.
function centerAspectCrop(
  mediaWidth: number,
  mediaHeight: number,
  aspect: number
) {
  return centerCrop(
    makeAspectCrop(
      {
        unit: "%",
        width: 100,
      },
      aspect,
      mediaWidth,
      mediaHeight
    ),
    mediaWidth,
    mediaHeight
  );
}

const defaultMemberIds: string[] = [];

const defaultImageUrls = [
  "https://plus.unsplash.com/premium_photo-1671656349322-41de944d259b?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8cG9ydHJhaXR8ZW58MHx8MHx8fDA%3D",
  "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8cG9ydHJhaXR8ZW58MHx8MHx8fDA%3D",
  "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8cG9ydHJhaXR8ZW58MHx8MHx8fDA%3D",
  "https://plus.unsplash.com/premium_photo-1664298528358-790433ba0815?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OXx8cG9ydHJhaXR8ZW58MHx8MHx8fDA%3D",
  "https://images.unsplash.com/photo-1514626585111-9aa86183ac98?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTV8fHBvcnRyYWl0fGVufDB8fDB8fHww",
  "https://plus.unsplash.com/premium_photo-1683140621573-233422bfc7f1?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTd8fHBvcnRyYWl0fGVufDB8fDB8fHww",
  "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTl8fHBvcnRyYWl0fGVufDB8fDB8fHww",
  "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8cG9ydHJhaXR8ZW58MHx8MHx8fDA%3D",
  "https://images.unsplash.com/photo-1502823403499-6ccfcf4fb453?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8cG9ydHJhaXR8ZW58MHx8MHx8fDA%3D",
  "https://images.unsplash.com/photo-1529408570047-e4414fb17e95?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8cG9ydHJhaXR8ZW58MHx8MHx8fDA%3D",
];

export default function App() {
  const [textarea, setTextarea] = useState("");
  const [memberIds, setMemberIds] = useState<string[]>(defaultMemberIds);
  const [index, setIndex] = useState<number | null>(0);
  const [member, setMember] = useState<Member | null>(null);
  const [loading, setLoading] = useState<boolean>(false);

  const apiKey = new URLSearchParams(window.location.search).get("k");

  useEffect(() => {
    if (index === null || memberIds.length === 0) return;
    const memberId = memberIds[index];
    const fetchMember = async () => {
      setLoading(true);
      try {
        const myHeaders = new Headers();
        myHeaders.append("Accept", "application/json");
        myHeaders.append(
          "Authorization",
          "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIzIiwianRpIjoiMjExZTg2MGYzMjM4YjQ0YjVlYTNiZTc4ZjYxMTI0MzQ1ZTQwNzAyM2Q3NGI1YzA2Y2E5ZjUzYWViN2ExNjljMDQ0YmJjYjQwNDVlMzllMmEiLCJpYXQiOiIxNzIzMTA5ODU2Ljc0NjY4MCIsIm5iZiI6IjE3MjMxMDk4NTYuNzQ2Njg0IiwiZXhwIjoiMTc1NDY0NTg1Ni43Mzg2ODkiLCJzdWIiOiIiLCJzY29wZXMiOlsiKiJdfQ.uy8ZK3ooCCkvGoVf30XSz5Ln3wrV-sVr4ZatNoVbInpJyZDvo6oRzFaNIzm6YqffhiF_RZeGzJJJwhdrzH-6_zmW0vXYwd7DdyHyPauhvUlVDa-tO718gspcUGb32dVb0S780ocZwiNuoKQhLVpKmaUBuEyviAoeIYdeZbhrVL6aah2Gk9vMCWtoUiMKn7RfwDkrPAPDIo7EVoSBrdZT4ZSpsWMyIjscTsgueCylJTf7SZMaEwqGmpRasVpfu9Ye36LfVFdhvfyBMVzediFs5-U1xpD7L5ilrl54XJJt5tr0SjrQ8-_Q4zgHKchw0CkMQsZY2zMet3nEwOkxRYL7XxxRVn0UOu9BqLrBvBwOJXDQMQ5aPaGBKZ0HBXncd3dWitXT_nlXlySJUpKqDUKLluQWD3PWbafqXHc-aSURVcYbojza20uKXo6-dYPKo8mzIWk7rcURjCEx0oJTOqx5_5qzjtNkUDPFmalSYXvrY_tHFwBuGKc3CUNrQgb42Mo8fxAZAzxRvYBELiPMHj1S5F4zKZwMh_AopDW7zIh_fhfILv_6cjPPwWCPB1HRN1VqnuriotrPSVy5UbJyvqBec8-kq4-KbCqKaIuL8CUP0N5Mg4I-6Zba2M1DNuENX5WArHTdnZRTn5YY3jI4S0ZYNCmfGhwio1OCeq9AmmHuYxA"
        );
        myHeaders.append("Content-Type", "application/json");
        if (apiKey) {
          myHeaders.append("X-API-Key", apiKey);
        }

        const raw = JSON.stringify({
          data: {
            search_type: "SERIAL",
            search_data: memberId,
          },
        });

        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow",
        };

        const resp = await fetch(
          "https://accounts-api.peoplesparty.or.th/api/public/v1/memberships/search",
          requestOptions
        );
        const result = await resp.json();
        const member: Member = result.data;
        member.profile_image_url = member.profile_image_url
          ? `https://still-mud-b5f0.panjamapong-s.workers.dev/${member.profile_image_url}`
          : undefined;
        // member.profile_image_url =
        //   defaultImageUrls[Math.floor(Math.random() * defaultImageUrls.length)];
        setMember(member);
      } finally {
        setLoading(false);
      }
    };
    fetchMember();
    return () => {};
  }, [index, memberIds, setMember]);
  // const member = index === null ? null : members[index];
  // const imgSrc = index === null ? null : members[index].profile_image_url;
  // const [imgSrc, setImgSrc] = useState(
  //   "https://plus.unsplash.com/premium_photo-1671656349322-41de944d259b?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8cG9ydHJhaXR8ZW58MHx8MHx8fDA%3D"
  // );
  const previewCanvasRef = useRef<HTMLCanvasElement>(null);
  const imgRef = useRef<HTMLImageElement>(null);
  const hiddenAnchorRef = useRef<HTMLAnchorElement>(null);
  const blobUrlRef = useRef("");
  const [crop, setCrop] = useState<Crop>();
  const [completedCrop, setCompletedCrop] = useState<PixelCrop>();
  const [scale, setScale] = useState(1);
  const [rotate, setRotate] = useState(0);
  const aspect = 404 / 508;

  function onImageLoad(e: React.SyntheticEvent<HTMLImageElement>) {
    if (aspect) {
      const { width, height } = e.currentTarget;
      setCrop(centerAspectCrop(width, height, aspect));
    }
  }

  async function onDownloadCropClick() {
    if (!member) return;
    const image = imgRef.current;
    const previewCanvas = previewCanvasRef.current;
    if (!image || !previewCanvas || !completedCrop) {
      throw new Error("Crop canvas does not exist");
    }

    // This will size relative to the uploaded image
    // size. If you want to size according to what they
    // are looking at on screen, remove scaleX + scaleY
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;

    // const offscreen = new OffscreenCanvas(
    //   completedCrop.width * scaleX,
    //   completedCrop.height * scaleY
    // );
    const offscreen = new OffscreenCanvas(404, 508);

    const ctx = offscreen.getContext("2d");
    if (!ctx) {
      throw new Error("No 2d context");
    }

    ctx.drawImage(
      previewCanvas,
      0,
      0,
      previewCanvas.width,
      previewCanvas.height,
      0,
      0,
      offscreen.width,
      offscreen.height
    );
    // You might want { type: "image/jpeg", quality: <0 to 1> } to
    // reduce image size
    // const blob = await offscreen.convertToBlob({
    //   type: "image/jpeg",
    //   quality: 0.8,
    // });

    const blob = await offscreen.convertToBlob({
      type: "image/png",
    });

    if (blobUrlRef.current) {
      URL.revokeObjectURL(blobUrlRef.current);
    }
    blobUrlRef.current = URL.createObjectURL(blob);

    if (hiddenAnchorRef.current) {
      hiddenAnchorRef.current.setAttribute("download", `${member.serial}.jpg`);
      hiddenAnchorRef.current.href = blobUrlRef.current;
      hiddenAnchorRef.current.click();
    }
  }

  useKeypress(["ArrowRight", "ArrowLeft"], (event: KeyboardEvent) => {
    if (
      event.key === "ArrowRight" &&
      index !== null &&
      index < memberIds.length - 1
    ) {
      setIndex(index + 1);
      setCrop(undefined);
    }
    if (event.key === "ArrowLeft" && index !== null && index > 0) {
      setIndex(index - 1);
      setCrop(undefined);
    }
  });

  useEffect(() => {
    if (
      completedCrop?.width &&
      completedCrop?.height &&
      imgRef.current &&
      previewCanvasRef.current
    ) {
      // We use canvasPreview as it's much faster than imgPreview.
      canvasPreview(
        imgRef.current,
        previewCanvasRef.current,
        completedCrop,
        scale,
        rotate
      );
    }
    return () => {};
  }, [completedCrop, imgRef.current, scale, rotate]);

  return (
    <div className="App" style={{ display: "flex", flexDirection: "row" }}>
      <div style={{ width: "50%" }}>
        <div style={{ display: "flex", flexDirection: "row" }}>
          <Textarea
            style={{ width: "50%", height: "1em" }}
            value={textarea}
            onChange={(e) => setTextarea(e.target.value)}
          />
          <Button
            onClick={() => {
              setMemberIds(
                textarea
                  .split("\n")
                  .filter((a) => a.length > 0 && a.match(new RegExp(/^\d+$/g)))
              );
              setIndex(0);
            }}
            disabled={textarea.length === 0}
            startDecorator={<Search />}
          >
            เรียกดู ({textarea.split("\n").filter((a) => a.length > 0).length})
          </Button>
          <Button
            startDecorator={<Clear />}
            color="neutral"
            onClick={() => {
              setTextarea("");
              setMemberIds([]);
              setIndex(null);
            }}
          >
            ล้างค่า
          </Button>
        </div>

        {member && !member.profile_image_url && (
          <div style={{ fontSize: "50px", marginTop: "50px" }}>
            ไม่มีภาพ ({member.serial})
          </div>
        )}
        {member && member.profile_image_url && (
          <>
            <div>
              {scale == 1 ? (
                <Button
                  startDecorator={<ZoomInMap />}
                  color="success"
                  onClick={() => {
                    setScale(0.5);
                  }}
                >
                  ย่อ
                </Button>
              ) : (
                <Button
                  startDecorator={<ZoomOutMap />}
                  color="success"
                  onClick={() => {
                    setScale(1);
                  }}
                >
                  ขยาย
                </Button>
              )}

              <Button
                startDecorator={<Rotate90DegreesCw />}
                color="danger"
                style={{ marginLeft: "10px" }}
                onClick={() => {
                  setRotate((rotate + 90) % 360);
                }}
              >
                หมุน
              </Button>
            </div>
            <ReactCrop
              crop={crop}
              onChange={(_, percentCrop) => setCrop(percentCrop)}
              onComplete={(c) => setCompletedCrop(c)}
              aspect={aspect}
              // minWidth={400}
              // minHeight={100}
              // circularCrop
            >
              <img
                ref={imgRef}
                alt="Crop me"
                src={member.profile_image_url}
                crossOrigin="anonymous"
                style={{
                  maxHeight: "calc(100vh - 130px)",
                  transform: `scale(${scale}) rotate(${rotate}deg)`,
                }}
                onLoad={onImageLoad}
              />
            </ReactCrop>
          </>
        )}
      </div>
      <div style={{ width: "50%" }}>
        {!!completedCrop && !loading && index !== null && member && (
          <>
            <div>
              <Button
                disabled={index == 0 || loading}
                onClick={() => {
                  setIndex(index - 1);
                  setCrop(undefined);
                  setScale(1);
                  setRotate(0);
                }}
                startDecorator={<ArrowBack />}
              >
                ก่อนหน้า
              </Button>
              <Button
                startDecorator={<FileDownload />}
                onClick={onDownloadCropClick}
                style={{ margin: "0 20px" }}
                disabled={loading}
              >
                ดาวน์โหลด {`${member.serial}.jpg`}
              </Button>
              <a
                href="#hidden"
                ref={hiddenAnchorRef}
                download
                style={{
                  position: "absolute",
                  top: "-200vh",
                  visibility: "hidden",
                }}
              >
                Hidden download
              </a>
              <Button
                disabled={index == memberIds.length - 1 || loading}
                onClick={() => {
                  setIndex(index + 1);
                  setCrop(undefined);
                  setScale(1);
                  setRotate(0);
                }}
                endDecorator={<ArrowForward />}
              >
                ถัดไป
              </Button>
            </div>
            {member && member.profile_image_url && (
              <div style={{ position: "relative" }}>
                <img
                  style={{
                    position: "absolute",
                    height: "calc(100vh - 80px)",
                  }}
                  src={`/images/card-${member.membership_type}.png`}
                />
                <canvas
                  ref={previewCanvasRef}
                  style={{
                    position: "absolute",
                    height: "calc(100vh - 80px)",
                    // border: "1px solid black",
                    objectFit: "contain",
                    transform: "scale(0.499) translate(-40%,-41.3%)",
                    // width: "208px",
                    // height: "262px",
                  }}
                />
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
